import { useEffect } from 'react';

interface UseEmployeeBreakActionModalEffectsParams {
  syncFormAndCheckBreakConflicts: () => void;
}

export const useEmployeeBreakActionModalEffects = ({
  syncFormAndCheckBreakConflicts,
}: UseEmployeeBreakActionModalEffectsParams) => {
  useEffect(() => {
    syncFormAndCheckBreakConflicts();
  }, [syncFormAndCheckBreakConflicts]);
};
